import React from 'react';

import { FieldLabel, FormGroup, Tooltip } from '../../components';
import { styled } from '../../theme';
import Button from './Button';

const Container = styled('div')(({ theme }) => ({
    width: 'fit-content',
    background: theme.gradients.tertiary1,
    borderRadius: theme.borderRadius.base,
}));

type Props = {
    label?: string;
    labelStyles?: any;
    value: any;
    options: any[];
    mapValueToLabel: (value: any) => string;
    onSelect: (value: any) => void;
    buttonStyle?: object;
    renderTooltipTitle?: (optionValue: any) => string;
};

const HorizontalButtonGroup: React.FC<Props> = ({
    className,
    label,
    labelStyles,
    value,
    options,
    mapValueToLabel,
    onSelect,
    buttonStyle,
    renderTooltipTitle,
    ...props
}) => {
    if (!(options && options.length > 1)) {
        return null;
    }

    return (
        <FormGroup className={className}>
            {label && <FieldLabel style={labelStyles}>{label}</FieldLabel>}
            <Container>
                {options.map((optionValue) => {
                    const button = (
                        <Button
                            key={optionValue.toString()}
                            value={optionValue}
                            label={
                                mapValueToLabel
                                    ? mapValueToLabel(optionValue)
                                    : optionValue.toString()
                            }
                            isSelected={optionValue === value}
                            handleClick={onSelect}
                            style={buttonStyle}
                            {...props}
                        />
                    );
                    if (renderTooltipTitle) {
                        return (
                            <Tooltip
                                key={`tooltip-${optionValue}`}
                                placement="top"
                                title={renderTooltipTitle(optionValue)}
                            >
                                {button}
                            </Tooltip>
                        );
                    }

                    return button;
                })}
            </Container>
        </FormGroup>
    );
};

export default HorizontalButtonGroup;
